import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { take } from 'rxjs/operators';

import { AuthenticationSandbox } from '../sandbox/authentication.sandbox';

@Injectable({ providedIn: 'root' })
export class SkipLoginGuard {
    // Application will get stuck if oauth redirects to one of these
    private readonly entryNavBlackList: string[] = ['token', 'auth/redirect'];
    constructor(private readonly sandbox: AuthenticationSandbox) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {
        if (this.sandbox.canSkipLogin()) {
            const entryNavigationUrl: string | null = route.queryParamMap.get('entryNavigationUrl');
            const safeUrl: string =
                !!entryNavigationUrl && !this.entryNavBlackList.includes(entryNavigationUrl) ? entryNavigationUrl : '/';
            this.navigateToOauthFlow(safeUrl);
            return false;
        } else {
            return true;
        }
    }

    navigateToOauthFlow(entryNavigationUrl: string): void {
        this.sandbox
            .getNewStatefulOauthUrl(entryNavigationUrl)
            .pipe(take(1))
            .subscribe(oauthUrl => {
                window.location.href = oauthUrl;
            });
    }
}
